module.exports = __webpack_public_path__ + "img/Portugués_A1.1.f961084a.jpg";